import { React, useEffect, useState } from 'react'
import CreatePostForm from "../components/CreatePostForm";
import Post from "../components/Post"
import ArticleList from "../components/ArticleList"
import { Autocomplete } from '@mantine/core';
import { database } from './firebaseConfig';
import { ref, onValue } from "firebase/database";

function Knowledgebase(props) {

  const [search, setSearch] = useState(''); // Represents what is in the search parameter
  const [posts, setPosts] = useState([]); // represents all posts

  const [displayedPosts, setDisplayedPosts] = useState([]);

  useEffect(() => {
      var temp = [];
      // Get all of the titles and append them to titles
      try {  
      onValue(ref(database, `knowledgebase`), async (snapshot) => {
          snapshot.forEach(child => {
            temp.push(child.toJSON());
          });
        
          setPosts(temp);
      });

    } catch (error) {
        console.log(error);
    }
  }, [props]);

  /**
   * Called when an element is selected from the Posts search bar
   * @param {*} value 
   */
  function onSearchSubmit(value) {
     // Remove searches if value is null or undefined
     if(value === null || value === undefined || value.trim().length === 0) {
        setDisplayedPosts([]);
        return;
     }

     setDisplayedPosts(posts.filter(n=> n.title !== null && n.title !== undefined && n.title === value));
  }

  /**
   * Called when the value of Autocomplete for search is called
   * @param {*} value 
   */
  function setSearchValue(value) {
      setSearch(value);
      // Remove searches if value is null or undefined
      if(value === null || value === undefined || value.trim().length === 0) {
        setDisplayedPosts([]);
      }
  }

  /**
   * Called when an article is clicked from the ArticleList
   * @param {string} title - The title of the article to display
   */
  function handleArticleClick(title) {
      setSearch(title);
      setDisplayedPosts(posts.filter(n => n.title !== null && n.title !== undefined && n.title === title));
  }

  return (

    <div className='knowledgebase'>

      {/* Autocomplete tab for searching data */}
      <div className='search'>
        <Autocomplete label="Search" onOptionSubmit={onSearchSubmit} 
        data={posts.map(n => (n.title === null || n.title === undefined) ? null : n.title).filter((value, index, array) => array.indexOf(value) === index)} 
        value={search} onChange={setSearchValue} 
        comboboxProps={{ shadow: 'md', transitionProps: { transition: 'pop', duration: 200 } }}/>
      </div>

      {/* Main content area with sidebar and posts */}
      <div className='knowledgebase-content'>
        {/* Left sidebar with article list */}
        <div className='article-sidebar'>
          <ArticleList posts={posts} onArticleClick={handleArticleClick} />
        </div>

        {/* Right side with displayed posts */}
        <div className='posts-main'>
          {/* Display a list of posts from displayedPosts */}
          <div className='posts' style={{ paddingTop: '20px', height: 'fit-content' }}>
            {displayedPosts.map((n) => {     
               return (<Post key={n.title} userID={n.maintainer} userEmail={n.maintainer_email} createTime={n.creationTime} updateTime={n.updateTime} information={n.information} title={n.title} tags={n.tags} resources={n.resources} in_comments={n.in_comments} />  
               ) 
            })}
          </div>
        </div>
      </div>

      <CreatePostForm></CreatePostForm>

    </div>

    
  )
}

export default Knowledgebase
